var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 123,
    viewBox: "0 0 177 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56703 6.21812L3.85743 9.51874C3.55042 10.1115 3.90015 10.8329 4.55609 10.9599L5.57827 11.1578C6.11961 11.2626 6.64355 10.91 6.74976 10.3695L7.43718 6.87096C7.66005 5.7367 6.09871 5.19166 5.56703 6.21812Z",
    fill: "url(#paint0_linear_231_1205)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8991 6.21812L20.1895 9.51874C19.8824 10.1115 20.2322 10.8329 20.8881 10.9599L21.9103 11.1578C22.4516 11.2626 22.9756 10.91 23.0818 10.3695L23.7692 6.87096C23.9921 5.7367 22.4307 5.19166 21.8991 6.21812Z",
    fill: "url(#paint1_linear_231_1205)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2291 6.21617L36.5195 9.51678C36.2125 10.1095 36.5623 10.8309 37.2182 10.9579L38.2404 11.1558C38.7817 11.2606 39.3057 10.9081 39.4119 10.3675L40.0993 6.86901C40.3222 5.73474 38.7608 5.18971 38.2291 6.21617Z",
    fill: "url(#paint2_linear_231_1205)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5631 6.21812L52.8535 9.51874C52.5465 10.1115 52.8962 10.8329 53.5522 10.9599L54.5744 11.1578C55.1157 11.2626 55.6396 10.91 55.7459 10.3695L56.4333 6.87096C56.6561 5.7367 55.0948 5.19166 54.5631 6.21812Z",
    fill: "url(#paint3_linear_231_1205)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8932 6.21617L69.1836 9.51678C68.8766 10.1095 69.2263 10.8309 69.8823 10.9579L70.9044 11.1558C71.4458 11.2606 71.9697 10.9081 72.0759 10.3675L72.7634 6.86901C72.9862 5.73474 71.4249 5.18971 70.8932 6.21617Z",
    fill: "url(#paint4_linear_231_1205)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2252 6.21812L85.5156 9.51874C85.2086 10.1115 85.5584 10.8329 86.2143 10.9599L87.2365 11.1578C87.7778 11.2626 88.3018 10.91 88.408 10.3695L89.0954 6.87096C89.3183 5.7367 87.7569 5.19166 87.2252 6.21812Z",
    fill: "url(#paint5_linear_231_1205)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.555 6.21812L101.846 9.51874C101.539 10.1115 101.888 10.8329 102.544 10.9599L103.567 11.1578C104.108 11.2626 104.632 10.91 104.738 10.3695L105.425 6.87096C105.648 5.7367 104.087 5.19166 103.555 6.21812Z",
    fill: "url(#paint6_linear_231_1205)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.889 6.21617L118.18 9.51678C117.873 10.1095 118.222 10.8309 118.878 10.9579L119.901 11.1558C120.442 11.2606 120.966 10.9081 121.072 10.3675L121.759 6.86901C121.982 5.73474 120.421 5.18971 119.889 6.21617Z",
    fill: "url(#paint7_linear_231_1205)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 6.21812L134.52 9.51874C134.213 10.1115 134.562 10.8329 135.218 10.9599L136.24 11.1578C136.782 11.2626 137.306 10.91 137.412 10.3695L138.099 6.87096C138.322 5.7367 136.761 5.19166 136.229 6.21812Z",
    fill: "url(#paint8_linear_231_1205)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 6.21617L150.861 9.51678C150.554 10.1095 150.904 10.8309 151.56 10.9579L152.582 11.1558C153.124 11.2606 153.647 10.9081 153.754 10.3675L154.441 6.86901C154.664 5.73474 153.103 5.18971 152.571 6.21617Z",
    fill: "url(#paint9_linear_231_1205)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.909 6.21812L167.199 9.51874C166.892 10.1115 167.242 10.8329 167.898 10.9599L168.92 11.1578C169.461 11.2626 169.985 10.91 170.092 10.3695L170.779 6.87096C171.002 5.7367 169.441 5.19166 168.909 6.21812Z",
    fill: "url(#paint10_linear_231_1205)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56703 28.1849L3.85743 31.4855C3.55042 32.0783 3.90015 32.7997 4.55609 32.9267L5.57827 33.1246C6.11961 33.2294 6.64355 32.8768 6.74976 32.3363L7.43718 28.8378C7.66005 27.7035 6.09871 27.1585 5.56703 28.1849Z",
    fill: "url(#paint11_linear_231_1205)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8991 28.1869L20.1895 31.4875C19.8824 32.0802 20.2322 32.8016 20.8881 32.9286L21.9103 33.1265C22.4516 33.2314 22.9756 32.8788 23.0818 32.3382L23.7692 28.8397C23.9921 27.7054 22.4307 27.1604 21.8991 28.1869Z",
    fill: "url(#paint12_linear_231_1205)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2291 28.1849L36.5195 31.4855C36.2125 32.0783 36.5623 32.7997 37.2182 32.9267L38.2404 33.1246C38.7817 33.2294 39.3057 32.8768 39.4119 32.3363L40.0993 28.8378C40.3222 27.7035 38.7608 27.1585 38.2291 28.1849Z",
    fill: "url(#paint13_linear_231_1205)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5631 28.1869L52.8535 31.4875C52.5465 32.0802 52.8962 32.8016 53.5522 32.9286L54.5744 33.1265C55.1157 33.2314 55.6396 32.8788 55.7459 32.3382L56.4333 28.8397C56.6561 27.7054 55.0948 27.1604 54.5631 28.1869Z",
    fill: "url(#paint14_linear_231_1205)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8932 28.1849L69.1836 31.4855C68.8766 32.0783 69.2263 32.7997 69.8823 32.9267L70.9044 33.1246C71.4458 33.2294 71.9697 32.8768 72.0759 32.3363L72.7634 28.8378C72.9862 27.7035 71.4249 27.1585 70.8932 28.1849Z",
    fill: "url(#paint15_linear_231_1205)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2252 28.1869L85.5156 31.4875C85.2086 32.0802 85.5584 32.8016 86.2143 32.9286L87.2365 33.1265C87.7778 33.2314 88.3018 32.8788 88.408 32.3382L89.0954 28.8397C89.3183 27.7054 87.7569 27.1604 87.2252 28.1869Z",
    fill: "url(#paint16_linear_231_1205)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.555 28.1869L101.846 31.4875C101.539 32.0802 101.888 32.8016 102.544 32.9286L103.567 33.1265C104.108 33.2314 104.632 32.8788 104.738 32.3382L105.425 28.8397C105.648 27.7054 104.087 27.1604 103.555 28.1869Z",
    fill: "url(#paint17_linear_231_1205)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.889 28.1849L118.18 31.4855C117.873 32.0783 118.222 32.7997 118.878 32.9267L119.901 33.1246C120.442 33.2294 120.966 32.8768 121.072 32.3363L121.759 28.8378C121.982 27.7035 120.421 27.1585 119.889 28.1849Z",
    fill: "url(#paint18_linear_231_1205)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 28.1869L134.52 31.4875C134.213 32.0802 134.562 32.8016 135.218 32.9286L136.24 33.1265C136.782 33.2314 137.306 32.8788 137.412 32.3382L138.099 28.8397C138.322 27.7054 136.761 27.1604 136.229 28.1869Z",
    fill: "url(#paint19_linear_231_1205)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 28.1849L150.861 31.4855C150.554 32.0783 150.904 32.7997 151.56 32.9267L152.582 33.1246C153.124 33.2294 153.647 32.8768 153.754 32.3363L154.441 28.8378C154.664 27.7035 153.103 27.1585 152.571 28.1849Z",
    fill: "url(#paint20_linear_231_1205)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.909 28.1869L167.199 31.4875C166.892 32.0802 167.242 32.8016 167.898 32.9286L168.92 33.1265C169.461 33.2314 169.985 32.8788 170.092 32.3382L170.779 28.8397C171.002 27.7054 169.441 27.1604 168.909 28.1869Z",
    fill: "url(#paint21_linear_231_1205)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56703 50.1576L3.85743 53.4582C3.55042 54.0509 3.90015 54.7723 4.55609 54.8993L5.57827 55.0972C6.11961 55.2021 6.64355 54.8495 6.74976 54.3089L7.43718 50.8104C7.66005 49.6762 6.09871 49.1311 5.56703 50.1576Z",
    fill: "url(#paint22_linear_231_1205)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8991 50.1576L20.1895 53.4582C19.8824 54.0509 20.2322 54.7723 20.8881 54.8993L21.9103 55.0972C22.4516 55.2021 22.9756 54.8495 23.0818 54.3089L23.7692 50.8104C23.9921 49.6762 22.4307 49.1311 21.8991 50.1576Z",
    fill: "url(#paint23_linear_231_1205)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2291 50.1556L36.5195 53.4562C36.2125 54.049 36.5623 54.7704 37.2182 54.8974L38.2404 55.0953C38.7817 55.2001 39.3057 54.8475 39.4119 54.307L40.0993 50.8085C40.3222 49.6742 38.7608 49.1292 38.2291 50.1556Z",
    fill: "url(#paint24_linear_231_1205)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5631 50.1576L52.8535 53.4582C52.5465 54.0509 52.8962 54.7723 53.5522 54.8993L54.5744 55.0972C55.1157 55.2021 55.6396 54.8495 55.7459 54.3089L56.4333 50.8104C56.6561 49.6762 55.0948 49.1311 54.5631 50.1576Z",
    fill: "url(#paint25_linear_231_1205)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8932 50.1556L69.1836 53.4562C68.8766 54.049 69.2263 54.7704 69.8823 54.8974L70.9044 55.0953C71.4458 55.2001 71.9697 54.8475 72.0759 54.307L72.7634 50.8085C72.9862 49.6742 71.4249 49.1292 70.8932 50.1556Z",
    fill: "url(#paint26_linear_231_1205)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2252 50.1576L85.5156 53.4582C85.2086 54.0509 85.5584 54.7723 86.2143 54.8993L87.2365 55.0972C87.7778 55.2021 88.3018 54.8495 88.408 54.3089L89.0954 50.8104C89.3183 49.6762 87.7569 49.1311 87.2252 50.1576Z",
    fill: "url(#paint27_linear_231_1205)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.555 50.1576L101.846 53.4582C101.539 54.0509 101.888 54.7723 102.544 54.8993L103.567 55.0972C104.108 55.2021 104.632 54.8495 104.738 54.3089L105.425 50.8104C105.648 49.6762 104.087 49.1311 103.555 50.1576Z",
    fill: "url(#paint28_linear_231_1205)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.889 50.1556L118.18 53.4562C117.873 54.049 118.222 54.7704 118.878 54.8974L119.901 55.0953C120.442 55.2001 120.966 54.8475 121.072 54.307L121.759 50.8085C121.982 49.6742 120.421 49.1292 119.889 50.1556Z",
    fill: "url(#paint29_linear_231_1205)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 50.1576L134.52 53.4582C134.213 54.0509 134.562 54.7723 135.218 54.8993L136.24 55.0972C136.782 55.2021 137.306 54.8495 137.412 54.3089L138.099 50.8104C138.322 49.6762 136.761 49.1311 136.229 50.1576Z",
    fill: "url(#paint30_linear_231_1205)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 50.1556L150.861 53.4562C150.554 54.049 150.904 54.7704 151.56 54.8974L152.582 55.0953C153.124 55.2001 153.647 54.8475 153.754 54.307L154.441 50.8085C154.664 49.6742 153.103 49.1292 152.571 50.1556Z",
    fill: "url(#paint31_linear_231_1205)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M168.909 50.1576L167.199 53.4582C166.892 54.0509 167.242 54.7723 167.898 54.8993L168.92 55.0972C169.461 55.2021 169.985 54.8495 170.092 54.3089L170.779 50.8104C171.002 49.6762 169.441 49.1311 168.909 50.1576Z",
    fill: "url(#paint32_linear_231_1205)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56703 72.1224L3.85743 75.423C3.55042 76.0158 3.90015 76.7372 4.55609 76.8642L5.57827 77.0621C6.11961 77.1669 6.64355 76.8143 6.74976 76.2738L7.43718 72.7753C7.66005 71.641 6.09871 71.096 5.56703 72.1224Z",
    fill: "url(#paint33_linear_231_1205)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8991 72.1244L20.1895 75.425C19.8824 76.0177 20.2322 76.7391 20.8881 76.8661L21.9103 77.064C22.4516 77.1689 22.9756 76.8163 23.0818 76.2757L23.7692 72.7772C23.9921 71.6429 22.4307 71.0979 21.8991 72.1244Z",
    fill: "url(#paint34_linear_231_1205)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2291 72.1224L36.5195 75.423C36.2125 76.0158 36.5623 76.7372 37.2182 76.8642L38.2404 77.0621C38.7817 77.1669 39.3057 76.8143 39.4119 76.2738L40.0993 72.7753C40.3222 71.641 38.7608 71.096 38.2291 72.1224Z",
    fill: "url(#paint35_linear_231_1205)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5631 72.1244L52.8535 75.425C52.5465 76.0177 52.8962 76.7391 53.5522 76.8661L54.5744 77.064C55.1157 77.1689 55.6396 76.8163 55.7459 76.2757L56.4333 72.7772C56.6561 71.6429 55.0948 71.0979 54.5631 72.1244Z",
    fill: "url(#paint36_linear_231_1205)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8932 72.1224L69.1836 75.423C68.8766 76.0158 69.2263 76.7372 69.8823 76.8642L70.9044 77.0621C71.4458 77.1669 71.9697 76.8143 72.0759 76.2738L72.7634 72.7753C72.9862 71.641 71.4249 71.096 70.8932 72.1224Z",
    fill: "url(#paint37_linear_231_1205)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2252 72.1244L85.5156 75.425C85.2086 76.0177 85.5584 76.7391 86.2143 76.8661L87.2365 77.064C87.7778 77.1689 88.3018 76.8163 88.408 76.2757L89.0954 72.7772C89.3183 71.6429 87.7569 71.0979 87.2252 72.1244Z",
    fill: "url(#paint38_linear_231_1205)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.555 72.1244L101.846 75.425C101.539 76.0177 101.888 76.7391 102.544 76.8661L103.567 77.064C104.108 77.1689 104.632 76.8163 104.738 76.2757L105.425 72.7772C105.648 71.6429 104.087 71.0979 103.555 72.1244Z",
    fill: "url(#paint39_linear_231_1205)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M119.889 72.1224L118.18 75.423C117.873 76.0158 118.222 76.7372 118.878 76.8642L119.901 77.0621C120.442 77.1669 120.966 76.8143 121.072 76.2738L121.759 72.7753C121.982 71.641 120.421 71.096 119.889 72.1224Z",
    fill: "url(#paint40_linear_231_1205)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 72.1244L134.52 75.425C134.213 76.0177 134.562 76.7391 135.218 76.8661L136.24 77.064C136.782 77.1689 137.306 76.8163 137.412 76.2757L138.099 72.7772C138.322 71.6429 136.761 71.0979 136.229 72.1244Z",
    fill: "url(#paint41_linear_231_1205)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 72.1224L150.861 75.423C150.554 76.0158 150.904 76.7372 151.56 76.8642L152.582 77.0621C153.124 77.1669 153.647 76.8143 153.754 76.2738L154.441 72.7753C154.664 71.641 153.103 71.096 152.571 72.1224Z",
    fill: "url(#paint42_linear_231_1205)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M168.909 72.1244L167.199 75.425C166.892 76.0177 167.242 76.7391 167.898 76.8661L168.92 77.064C169.461 77.1689 169.985 76.8163 170.092 76.2757L170.779 72.7772C171.002 71.6429 169.441 71.0979 168.909 72.1244Z",
    fill: "url(#paint43_linear_231_1205)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56703 94.0951L3.85743 97.3957C3.55042 97.9884 3.90015 98.7098 4.55609 98.8368L5.57827 99.0347C6.11961 99.1396 6.64355 98.787 6.74976 98.2464L7.43718 94.7479C7.66005 93.6137 6.09871 93.0686 5.56703 94.0951Z",
    fill: "url(#paint44_linear_231_1205)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8991 94.0951L20.1895 97.3957C19.8824 97.9884 20.2322 98.7098 20.8881 98.8368L21.9103 99.0347C22.4516 99.1396 22.9756 98.787 23.0818 98.2464L23.7692 94.7479C23.9921 93.6137 22.4307 93.0686 21.8991 94.0951Z",
    fill: "url(#paint45_linear_231_1205)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2291 94.0931L36.5195 97.3937C36.2125 97.9865 36.5623 98.7079 37.2182 98.8349L38.2404 99.0328C38.7817 99.1376 39.3057 98.785 39.4119 98.2445L40.0993 94.746C40.3222 93.6117 38.7608 93.0667 38.2291 94.0931Z",
    fill: "url(#paint46_linear_231_1205)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5631 94.0951L52.8535 97.3957C52.5465 97.9884 52.8962 98.7098 53.5522 98.8368L54.5744 99.0347C55.1157 99.1396 55.6396 98.787 55.7459 98.2464L56.4333 94.7479C56.6561 93.6137 55.0948 93.0686 54.5631 94.0951Z",
    fill: "url(#paint47_linear_231_1205)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8932 94.0931L69.1836 97.3937C68.8766 97.9865 69.2263 98.7079 69.8823 98.8349L70.9044 99.0328C71.4458 99.1376 71.9697 98.785 72.0759 98.2445L72.7634 94.746C72.9862 93.6117 71.4249 93.0667 70.8932 94.0931Z",
    fill: "url(#paint48_linear_231_1205)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2252 94.0951L85.5156 97.3957C85.2086 97.9884 85.5584 98.7098 86.2143 98.8368L87.2365 99.0347C87.7778 99.1396 88.3018 98.787 88.408 98.2464L89.0954 94.7479C89.3183 93.6137 87.7569 93.0686 87.2252 94.0951Z",
    fill: "url(#paint49_linear_231_1205)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M103.555 94.0951L101.846 97.3957C101.539 97.9884 101.888 98.7098 102.544 98.8368L103.567 99.0347C104.108 99.1396 104.632 98.787 104.738 98.2464L105.425 94.7479C105.648 93.6137 104.087 93.0686 103.555 94.0951Z",
    fill: "url(#paint50_linear_231_1205)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M119.889 94.0931L118.18 97.3937C117.873 97.9865 118.222 98.7079 118.878 98.8349L119.901 99.0328C120.442 99.1376 120.966 98.785 121.072 98.2445L121.759 94.746C121.982 93.6117 120.421 93.0667 119.889 94.0931Z",
    fill: "url(#paint51_linear_231_1205)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 94.0951L134.52 97.3957C134.213 97.9884 134.562 98.7098 135.218 98.8368L136.24 99.0347C136.782 99.1396 137.306 98.787 137.412 98.2464L138.099 94.7479C138.322 93.6137 136.761 93.0686 136.229 94.0951Z",
    fill: "url(#paint52_linear_231_1205)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 94.0931L150.861 97.3937C150.554 97.9865 150.904 98.7079 151.56 98.8349L152.582 99.0328C153.124 99.1376 153.647 98.785 153.754 98.2445L154.441 94.746C154.664 93.6117 153.103 93.0667 152.571 94.0931Z",
    fill: "url(#paint53_linear_231_1205)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M168.909 94.0951L167.199 97.3957C166.892 97.9884 167.242 98.7098 167.898 98.8368L168.92 99.0347C169.461 99.1396 169.985 98.787 170.092 98.2464L170.779 94.7479C171.002 93.6137 169.441 93.0686 168.909 94.0951Z",
    fill: "url(#paint54_linear_231_1205)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56703 116.062L3.85743 119.362C3.55042 119.955 3.90015 120.677 4.55609 120.804L5.57827 121.002C6.11961 121.106 6.64355 120.754 6.74976 120.213L7.43718 116.715C7.66005 115.58 6.09871 115.035 5.56703 116.062Z",
    fill: "url(#paint55_linear_231_1205)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8991 116.064L20.1895 119.364C19.8824 119.957 20.2322 120.679 20.8881 120.806L21.9103 121.003C22.4516 121.108 22.9756 120.756 23.0818 120.215L23.7692 116.717C23.9921 115.582 22.4307 115.037 21.8991 116.064Z",
    fill: "url(#paint56_linear_231_1205)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2291 116.062L36.5195 119.362C36.2125 119.955 36.5623 120.677 37.2182 120.804L38.2404 121.002C38.7817 121.106 39.3057 120.754 39.4119 120.213L40.0993 116.715C40.3222 115.58 38.7608 115.035 38.2291 116.062Z",
    fill: "url(#paint57_linear_231_1205)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5631 116.064L52.8535 119.364C52.5465 119.957 52.8962 120.679 53.5522 120.806L54.5744 121.003C55.1157 121.108 55.6396 120.756 55.7459 120.215L56.4333 116.717C56.6561 115.582 55.0948 115.037 54.5631 116.064Z",
    fill: "url(#paint58_linear_231_1205)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8932 116.062L69.1836 119.362C68.8766 119.955 69.2263 120.677 69.8823 120.804L70.9044 121.002C71.4458 121.106 71.9697 120.754 72.0759 120.213L72.7634 116.715C72.9862 115.58 71.4249 115.035 70.8932 116.062Z",
    fill: "url(#paint59_linear_231_1205)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2252 116.064L85.5156 119.364C85.2086 119.957 85.5584 120.679 86.2143 120.806L87.2365 121.003C87.7778 121.108 88.3018 120.756 88.408 120.215L89.0954 116.717C89.3183 115.582 87.7569 115.037 87.2252 116.064Z",
    fill: "url(#paint60_linear_231_1205)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M103.555 116.064L101.846 119.364C101.539 119.957 101.888 120.679 102.544 120.806L103.567 121.003C104.108 121.108 104.632 120.756 104.738 120.215L105.425 116.717C105.648 115.582 104.087 115.037 103.555 116.064Z",
    fill: "url(#paint61_linear_231_1205)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M119.889 116.062L118.18 119.362C117.873 119.955 118.222 120.677 118.878 120.804L119.901 121.002C120.442 121.106 120.966 120.754 121.072 120.213L121.759 116.715C121.982 115.58 120.421 115.035 119.889 116.062Z",
    fill: "url(#paint62_linear_231_1205)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 116.064L134.52 119.364C134.213 119.957 134.562 120.679 135.218 120.806L136.24 121.003C136.782 121.108 137.306 120.756 137.412 120.215L138.099 116.717C138.322 115.582 136.761 115.037 136.229 116.064Z",
    fill: "url(#paint63_linear_231_1205)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 116.062L150.861 119.362C150.554 119.955 150.904 120.677 151.56 120.804L152.582 121.002C153.124 121.106 153.647 120.754 153.754 120.213L154.441 116.715C154.664 115.58 153.103 115.035 152.571 116.062Z",
    fill: "url(#paint64_linear_231_1205)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M168.909 116.064L167.199 119.364C166.892 119.957 167.242 120.679 167.898 120.806L168.92 121.003C169.461 121.108 169.985 120.756 170.092 120.215L170.779 116.717C171.002 115.582 169.441 115.037 168.909 116.064Z",
    fill: "url(#paint65_linear_231_1205)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_1205",
    x1: 4.39345,
    y1: 2.44765,
    x2: 8.68785,
    y2: 10.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_231_1205",
    x1: 20.7255,
    y1: 2.44765,
    x2: 25.0199,
    y2: 10.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_231_1205",
    x1: 37.0556,
    y1: 2.4457,
    x2: 41.35,
    y2: 10.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_231_1205",
    x1: 53.3895,
    y1: 2.44765,
    x2: 57.6839,
    y2: 10.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_231_1205",
    x1: 69.7196,
    y1: 2.4457,
    x2: 74.014,
    y2: 10.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_231_1205",
    x1: 86.0517,
    y1: 2.44765,
    x2: 90.3461,
    y2: 10.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_231_1205",
    x1: 102.382,
    y1: 2.44765,
    x2: 106.676,
    y2: 10.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_231_1205",
    x1: 118.716,
    y1: 2.4457,
    x2: 123.01,
    y2: 10.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_231_1205",
    x1: 135.056,
    y1: 2.44765,
    x2: 139.35,
    y2: 10.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_231_1205",
    x1: 151.397,
    y1: 2.4457,
    x2: 155.692,
    y2: 10.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_231_1205",
    x1: 167.735,
    y1: 2.44765,
    x2: 172.03,
    y2: 10.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_231_1205",
    x1: 4.39345,
    y1: 24.4144,
    x2: 8.68785,
    y2: 32.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_231_1205",
    x1: 20.7255,
    y1: 24.4164,
    x2: 25.0199,
    y2: 32.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_231_1205",
    x1: 37.0556,
    y1: 24.4144,
    x2: 41.35,
    y2: 32.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_231_1205",
    x1: 53.3895,
    y1: 24.4164,
    x2: 57.6839,
    y2: 32.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_231_1205",
    x1: 69.7196,
    y1: 24.4144,
    x2: 74.014,
    y2: 32.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_231_1205",
    x1: 86.0517,
    y1: 24.4164,
    x2: 90.3461,
    y2: 32.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_231_1205",
    x1: 102.382,
    y1: 24.4164,
    x2: 106.676,
    y2: 32.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_231_1205",
    x1: 118.716,
    y1: 24.4144,
    x2: 123.01,
    y2: 32.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_231_1205",
    x1: 135.056,
    y1: 24.4164,
    x2: 139.35,
    y2: 32.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_231_1205",
    x1: 151.397,
    y1: 24.4144,
    x2: 155.692,
    y2: 32.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_231_1205",
    x1: 167.735,
    y1: 24.4164,
    x2: 172.03,
    y2: 32.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_231_1205",
    x1: 4.39345,
    y1: 46.3871,
    x2: 8.68785,
    y2: 54.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_231_1205",
    x1: 20.7255,
    y1: 46.3871,
    x2: 25.0199,
    y2: 54.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_231_1205",
    x1: 37.0556,
    y1: 46.3852,
    x2: 41.35,
    y2: 54.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_231_1205",
    x1: 53.3895,
    y1: 46.3871,
    x2: 57.6839,
    y2: 54.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_231_1205",
    x1: 69.7196,
    y1: 46.3852,
    x2: 74.014,
    y2: 54.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_231_1205",
    x1: 86.0517,
    y1: 46.3871,
    x2: 90.3461,
    y2: 54.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_231_1205",
    x1: 102.382,
    y1: 46.3871,
    x2: 106.676,
    y2: 54.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_231_1205",
    x1: 118.716,
    y1: 46.3852,
    x2: 123.01,
    y2: 54.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_231_1205",
    x1: 135.056,
    y1: 46.3871,
    x2: 139.35,
    y2: 54.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_231_1205",
    x1: 151.397,
    y1: 46.3852,
    x2: 155.692,
    y2: 54.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_231_1205",
    x1: 167.735,
    y1: 46.3871,
    x2: 172.03,
    y2: 54.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_231_1205",
    x1: 4.39345,
    y1: 68.3519,
    x2: 8.68785,
    y2: 76.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_231_1205",
    x1: 20.7255,
    y1: 68.3539,
    x2: 25.0199,
    y2: 76.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_231_1205",
    x1: 37.0556,
    y1: 68.3519,
    x2: 41.35,
    y2: 76.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_231_1205",
    x1: 53.3895,
    y1: 68.3539,
    x2: 57.6839,
    y2: 76.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_231_1205",
    x1: 69.7196,
    y1: 68.3519,
    x2: 74.014,
    y2: 76.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_231_1205",
    x1: 86.0517,
    y1: 68.3539,
    x2: 90.3461,
    y2: 76.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_231_1205",
    x1: 102.382,
    y1: 68.3539,
    x2: 106.676,
    y2: 76.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_231_1205",
    x1: 118.716,
    y1: 68.3519,
    x2: 123.01,
    y2: 76.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_231_1205",
    x1: 135.056,
    y1: 68.3539,
    x2: 139.35,
    y2: 76.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_231_1205",
    x1: 151.397,
    y1: 68.3519,
    x2: 155.692,
    y2: 76.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_231_1205",
    x1: 167.735,
    y1: 68.3539,
    x2: 172.03,
    y2: 76.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_231_1205",
    x1: 4.39345,
    y1: 90.3246,
    x2: 8.68785,
    y2: 98.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_231_1205",
    x1: 20.7255,
    y1: 90.3246,
    x2: 25.0199,
    y2: 98.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_231_1205",
    x1: 37.0556,
    y1: 90.3227,
    x2: 41.35,
    y2: 98.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_231_1205",
    x1: 53.3895,
    y1: 90.3246,
    x2: 57.6839,
    y2: 98.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_231_1205",
    x1: 69.7196,
    y1: 90.3227,
    x2: 74.014,
    y2: 98.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_231_1205",
    x1: 86.0517,
    y1: 90.3246,
    x2: 90.3461,
    y2: 98.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_231_1205",
    x1: 102.382,
    y1: 90.3246,
    x2: 106.676,
    y2: 98.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_231_1205",
    x1: 118.716,
    y1: 90.3227,
    x2: 123.01,
    y2: 98.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_231_1205",
    x1: 135.056,
    y1: 90.3246,
    x2: 139.35,
    y2: 98.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_231_1205",
    x1: 151.397,
    y1: 90.3227,
    x2: 155.692,
    y2: 98.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_231_1205",
    x1: 167.735,
    y1: 90.3246,
    x2: 172.03,
    y2: 98.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_231_1205",
    x1: 4.39345,
    y1: 112.291,
    x2: 8.68785,
    y2: 120.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_231_1205",
    x1: 20.7255,
    y1: 112.293,
    x2: 25.0199,
    y2: 120.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_231_1205",
    x1: 37.0556,
    y1: 112.291,
    x2: 41.35,
    y2: 120.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_231_1205",
    x1: 53.3895,
    y1: 112.293,
    x2: 57.6839,
    y2: 120.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_231_1205",
    x1: 69.7196,
    y1: 112.291,
    x2: 74.014,
    y2: 120.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_231_1205",
    x1: 86.0517,
    y1: 112.293,
    x2: 90.3461,
    y2: 120.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_231_1205",
    x1: 102.382,
    y1: 112.293,
    x2: 106.676,
    y2: 120.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_231_1205",
    x1: 118.716,
    y1: 112.291,
    x2: 123.01,
    y2: 120.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_231_1205",
    x1: 135.056,
    y1: 112.293,
    x2: 139.35,
    y2: 120.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_231_1205",
    x1: 151.397,
    y1: 112.291,
    x2: 155.692,
    y2: 120.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_231_1205",
    x1: 167.735,
    y1: 112.293,
    x2: 172.03,
    y2: 120.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FF7468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FE8E86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.253b9d74d9bc1c1e7e3cef8c2e56f7ed.svg";
export { ForwardRef as ReactComponent };